import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import * as LanguageService from "../../../services/languages.services";
import Breadcrums from "../../../common/breadcrumbs";
import Loader from "../../../common/loader";
import { formateDateWithMonth } from "../../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";

const LanguageView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();

  const [details, setDetails] = useState(null);
  const [loader, setLoader] = useState(true);

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("Languages"), url: "/admin/cms/languages/list/1" },
    { title: t("btn_view"), url: "" },
  ];

  useEffect(() => {
    if (params.id) {
      LanguageService.Details(params.id)
        .then((res) => {
          if (res.success && res.data) {
            setDetails(res.data);
          }
          setLoader(false);
        })
        .catch((err) => {
          console.log("Error loading language view:", err);
          setLoader(false);
        });
    }
  }, [params.id]);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">{t("Language Details")}</h6>
              <button
                className="btn ripple btn-secondary"
                onClick={() => navigate(-1)}
              >
                {t("btn_back")}
              </button>
            </div>

            {loader ? (
              <Loader />
            ) : details ? (
              <div className="row">
                <div className="col-md-6 mb-3">
                  <strong>{t("Title")}:</strong>
                  <p className="mt-1">{details.title || "N/A"}</p>
                </div>
                <div className="col-md-6 mb-3">
                  <strong>{t("Language Code")}:</strong>
                  <p className="mt-1">
                    <span className="badge bg-light text-dark fs-14">
                      {details.code || "N/A"}
                    </span>
                  </p>
                </div>
                <div className="col-md-6 mb-3">
                  <strong>{t("Sort Order")}:</strong>
                  <p className="mt-1">{details.sort_order ?? 0}</p>
                </div>
                <div className="col-md-6 mb-3">
                  <strong>{t("Status")}:</strong>
                  <p className="mt-1">
                    {details.status === 1 ? (
                      <span className="badge bg-success">{t("btn_active")}</span>
                    ) : (
                      <span className="badge bg-danger">{t("btn_inactive")}</span>
                    )}
                  </p>
                </div>
                <div className="col-md-6 mb-3">
                  <strong>{t("Created At")}:</strong>
                  <p className="mt-1">
                    {details.createdAt
                      ? formateDateWithMonth(details.createdAt)
                      : "N/A"}
                  </p>
                </div>
              </div>
            ) : (
              <p>{t("msg_no_records")}</p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default LanguageView;
